import { collections } from '@/mocks/homeData';

const toneMap: Record<string, { wrap: string; icon: string; count: string }> = {
  primary: {
    wrap: 'border-primary-200 bg-primary-50',
    icon: 'bg-primary-500 text-background-50',
    count: 'text-primary-700',
  },
  accent: {
    wrap: 'border-accent-200 bg-accent-50',
    icon: 'bg-accent-500 text-primary-950',
    count: 'text-accent-800',
  },
  secondary: {
    wrap: 'border-secondary-200 bg-secondary-50',
    icon: 'bg-secondary-500 text-background-50',
    count: 'text-secondary-700',
  },
};

export default function CollectionIndex() {
  return (
    <section id="collections" className="w-full border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">INDEX</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              合集索引
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              想系统补课就从这个索引进，每个合集都按主题分好类，条数一目了然。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 self-start whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-xs text-foreground-600 md:self-auto">
            <i className="ri-folder-open-line text-primary-500" aria-hidden="true" />
            共 {collections.length} 个精选合集
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => {
            const tone = toneMap[item.tone] ?? toneMap.primary;
            return (
              <a
                key={item.id}
                href="#community"
                className={`group flex flex-col rounded-lg border p-5 transition-transform hover:-translate-y-0.5 ${tone.wrap}`}
              >
                <div className="flex items-start justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${tone.icon}`}>
                    <i className={`${item.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <span className={`font-heading text-sm font-bold ${tone.count}`}>
                    {item.count}
                    <span className="ml-0.5 text-xs font-normal text-foreground-500">篇</span>
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-foreground-700">
                  进入合集
                  <i
                    className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"
                    aria-hidden="true"
                  />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}